<template>
    <b-alert :variant="variant" :show="true">
        <slot />
    </b-alert>
</template>

<script>
    export default {
        name: "Alert",
        props: {
            variant: {
                default: "info",
            },
        }
    }
</script>

<style>
.error.flash__message {
    background-color: #B56EC7 !important;
    color: white !important;
}
</style>
